export default {
    apiKey: "AIzaSyC1VQZ1Dncthk65d3LlDAUMGGnPGiayqR4",
    authDomain: "ourcardgame-1bbf5.firebaseapp.com",
    databaseURL: "https://ourcardgame-1bbf5.firebaseio.com",
    projectId: "ourcardgame-1bbf5",
    storageBucket: "ourcardgame-1bbf5.appspot.com",
    messagingSenderId: "642369103770",
    appId: "1:642369103770:web:1f98589e8b430c643c7c23",
    measurementId: "G-K6C8TFZMR7"
};